import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { WarningAmber, CheckCircleOutline, ErrorOutline } from '@mui/icons-material';

const ConfirmDialog = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel = 'Yes',
  cancelLabel = 'No',
  confirmColor = 'primary',
}) => {
  const getIcon = () => {
    if (confirmColor === 'error') return <ErrorOutline sx={{ fontSize: 28, color: 'error.main' }} />;
    if (confirmColor === 'success') return <CheckCircleOutline sx={{ fontSize: 28, color: 'success.main' }} />;
    return <WarningAmber sx={{ fontSize: 28, color: 'warning.main' }} />;
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {getIcon()}
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{
          color: 'text.secondary',
          fontSize: '0.95rem',
          lineHeight: 1.6
        }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onCancel}
          sx={{
            color: 'text.secondary',
            fontWeight: 500,
            px: 2.5,
            '&:hover': { bgcolor: 'grey.100' }
          }}
        >
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          color={confirmColor}
          variant="contained"
          sx={{
            px: 3,
            borderRadius: 2,
            boxShadow: 'none',
            '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
